import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Notification, { notifyApiError } from "components/Notification";
import Layout from "layouts/DashboardManage";
import Pagination from "components/Pagination";
import ManageDataTable from "components/ManageDataTable";
import ReactTooltip from "react-tooltip";
import ManageFilters from "../Forms/Elements/SearchManageComponents";
import {
  getAllUsers,
  deleteUser,
  resetPayload,
  DELETE_USER
} from "store/actions/userAction";
import { SpinnerRainbow } from "components/Spinner";
import NoData from "components/NoData";
import Translate from "helpers/Translate";

export class User extends Component {
  state = {
    showDeleteConfirm: false
  };

  componentDidMount() {
    this.props.getAllUsers({});
  }

  componentDidUpdate(prevProps) {
    if (prevProps.error !== this.props.error) {
      notifyApiError(this.props.error);
    }

    if (this.props.deleteStatus === 200) {
      Notification.success(
        Translate({ id: "the_user_will_be_deleted_in_the_next_60_seconds" }),
        {
          forceDelay: 7
        }
      );
      this.props.getAllUsers({});
      this.props.resetPayload(DELETE_USER);
    }
  }

  handleDelete = (e, item) => {
    e.preventDefault();
    const id = e.currentTarget.id || item.id;
    Notification.confirm(
      Translate({ id: "sure_to_delete", values: [item.fullname] }),
      {
        onOk: () => {
          this.props.deleteUser(id);
        }
      }
    );
  };

  onPageChange = data => {
    let selectedPage = parseInt(data.selected) + 1;
    this.props.getAllUsers({
      page: selectedPage
    });
  };

  hasData = () => {
    return (
      !this.props.isLoading &&
      this.props.users &&
      this.props.users.data &&
      this.props.users.data.length > 0
    );
  };

  render() {
    return (
      <Layout>
        <div className="manage">
          <Link className="back mb-20" to="/manage">
            <i className="fas fa-long-arrow-alt-left"></i>{" "}
            {Translate({ id: "back_to_manage_dashboard" })}
          </Link>
          <div className="manage-page-heading">
            <span className="manage-page-icon tone-green" aria-hidden="true">
              <i className="fas fa-user"></i>
            </span>
            <div className="manage-page-heading__text">
              <h1 className="title">{Translate({ id: "manage_users" })}</h1>
              <p className="manage-page-subtitle">
                {Translate({ id: "manage_users_description" })}
              </p>
            </div>
          </div>
          <div className="manage-list-actions">
            <div className="search-user-data">
              <ManageFilters
                id="search-user"
                getAllData={getAllUsers}
                placeholder="Search User"
                propertyField="name"
                propertyValue="fullname"
              />
            </div>
            <Link
              data-test="btnadd"
              to={`/manage/users/add`}
              className="btn btn-primary btn-add-manage"
            >
              <i className="fas fa-plus mr-10"></i>
              {Translate({ id: "add_user" })}
            </Link>
          </div>

          {this.props.isLoading && <SpinnerRainbow />}

          {!this.props.isLoading && (
            <ManageDataTable
              footer={
                this.hasData() ? (
                  <Pagination
                    onPageChange={this.onPageChange}
                    data={this.props.users && this.props.users.meta}
                  />
                ) : null
              }
            >
              <table>
                <thead>
                  <tr>
                    <th className="left">{Translate({ id: "fullname" })} </th>
                    <th className="left">{Translate({ id: "email" })} </th>
                    <th className="left">{Translate({ id: "role" })} </th>
                    <th className="left">{Translate({ id: "user_type" })} </th>
                    <th className="action-col">
                      {Translate({ id: "action" })}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {this.hasData() &&
                    this.props.users.data.map(item => (
                      <tr key={item.id}>
                        <td>{item.fullname}</td>
                        <td>{item.email}</td>
                        <td>{item?.role?.name || "--"}</td>
                        <td className="left">
                          <ReactTooltip />
                          {item?.user_type === "desktop" ? (
                            <i
                              className="fas fa-desktop"
                              data-tip={Translate({ id: "desktop_user" })}
                            ></i>
                          ) : (
                            <i
                              className="fas fa-globe"
                              data-tip={Translate({ id: "web_console_user" })}
                            ></i>
                          )}
                        </td>
                        <td className="action-col">
                          <div className="manage-data-table-actions">
                            <Link
                              className="action-btn action-edit"
                              data-tip={Translate({ id: "edit" })}
                              to={`/manage/users/edit/${item.id}`}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                            <Link
                              className="action-btn action-secondary"
                              data-tip={Translate({ id: "change_password" })}
                              to={`/manage/users/edit/${item.id}/password`}
                            >
                              <i className="fas fa-key"></i>
                            </Link>
                            <button
                              type="button"
                              className="action-btn action-delete"
                              data-tip={Translate({ id: "delete" })}
                              id={item.id}
                              onClick={e => this.handleDelete(e, item)}
                            >
                              <i className="fas fa-trash-alt" id={item.id}></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}

                  {!this.hasData() && (
                    <tr>
                      <td colSpan="100">
                        <NoData />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </ManageDataTable>
          )}
        </div>
      </Layout>
    );
  }
}

User.propTypes = {
  getAllUsers: PropTypes.func.isRequired,
  users: PropTypes.object,
  isLoading: PropTypes.bool,
  deleteStatus: PropTypes.number,
  error: PropTypes.object
};

const mapStateToProps = state => {
  return {
    users: state.user.getAllUsers,
    isLoading: state.user.isLoadingUser,
    deleteStatus: state.user.deleteUserStatus,
    error: state.user.errorUser
  };
};

export default connect(mapStateToProps, {
  getAllUsers,
  deleteUser,
  resetPayload
})(User);
